/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Add_Subject_Picker_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select a user or team" |
*
* @param {Rights_Add_Subject_Picker_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_add_subject_picker_placeholder = /** @type {((inputs?: Rights_Add_Subject_Picker_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Add_Subject_Picker_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzer oder Team auswählen")
	return /** @type {LocalizedString} */ ("Select a user or team")
});